export default __webpack_public_path__ + "static/Akkordeon-Five-c491a417880a93a80519470170cc91f5.woff";